module.exports = __webpack_public_path__ + "img/ScanTicket.bf29db49.jpg";